import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {
  stripAmountFormatting
} from '../../dst-amount.util';
import {toSaveString, safeEntityId} from '../../dst-save.util';

@Component({
    selector: 'dst-template-sec8858-id400',
    templateUrl: './template-sec8858-id400.component.html',
    styleUrls: ['../template-shared.scss', './template-sec8858-id400.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec8858Id400Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChild('taxOwnerLeidComp')
  private taxOwnerLeidComp!: TemplateLeidSelectorComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form400!: UntypedFormGroup;
  selectedOptionID!: Event;
  dcnId!: number;
  startLoader: boolean = false;
  statementId: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;

  beginDate!: Date;
  endDate!: Date;

  // LEID Entity Details
  reportingEntity!: DSTEntityDetails | null;  // Reporting Entity LEID
  fdeEntity!: DSTEntityDetails | null;        // DRC/Separate Unit LEID
  taxOwnerEntity!: DSTEntityDetails | null;   // Tax Owner LEID

  showDREMsg: boolean = false;
  DREMsg: string = '';

  // FDE/FB Info fields
  FDEOrFBName: string = '';
  FDEOrFBAddressLine1: string = '';
  FDEOrFBAddressLine2: string = '';
  FDEOrFBCity: string = '';
  FDEOrFBCountryCd: string = '';
  FDEOrFBPostalCd: string = '';
  FDEEIN: string = '';
  ForeignEntityRefIdNum: string = '';
  AnnualAcctPeriodBeginDt: string | Date = '';
  AnnualAcctPeriodEndDt: string | Date = '';
  selectedFDEFBType: number = -1;
  selectedReturnStatus: number = -1;
  selectedFDEFBTypeItem: any = null;
  selectedReturnStatusItem: any = null;

  // Tax Owner Info fields
  TaxOwnerName: string = '';
  TaxOwnerAddressLine1: string = '';
  TaxOwnerAddressLine2: string = '';
  TaxOwnerCity: string = '';
  TaxOwnerState: string = '';
  TaxOwnerZIP: string = '';
  TaxOwnerEIN: string = '';

  // Schedule G fields
  NetIncomeLossAmt: string = '';
  DualConsolidatedLossAmt: string = '';
  SeparateUnitDefinedInRegInd: boolean | undefined;
  SepCombSepDualCnsldtLossInd!: boolean;
  SepCombSepDualCnsldtLossAmt: string = '';
  DualCnsldtLossTaxableIncomeInd!: boolean;
  PermittedDomDualCnsldtLossInd: boolean | null = null;
  PrmtDomDualCnsldtLossDcmntnInd: boolean | null = null;
  CmptDualCnsldtLossTxblIncmInd: boolean | null = null;
  CumulativeRegisterAmt: string = '';
  TriggeringEventRecaptureInd!: boolean;
  TriggeringEventRecaptureAmt: string = '';

  nameChangeChecked: boolean = false;

  // FDE/FB Type dropdown
  FDEFBTypeOptions: DataEntity[] = [
    {value: '', label: '** Please select FDE/FB Type **'},
    {value: 'FDE', label: 'FDE of a U.S. Person'},
    {value: 'FB', label: 'FB of a U.S. Person'},
  ];

  // Return Status dropdown
  ReturnStatusOptions: DataEntity[] = [
    {value: '', label: '** Please select Return Status **'},
    {value: 'Initial', label: 'Initial Form 8858'},
    {value: 'Final', label: 'Final Form 8858'},
  ];

  CountryOptions: DataEntity[] = [];

  StateOptions: DataEntity[] = [];

  selectedCountry: number = -1;
  stateNameForTaxOwner: string = '';

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private trackerTabsService: TrackerTabsService,
              private cdref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.editMode = false;
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    this.form400 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      fdeInfo: this.formBuilder.group({
        ForeignEntityRefIdNum: [''],
        AnnualAcctPeriodBeginDt: [''],
        AnnualAcctPeriodEndDt: [''],
      }),
      taxOwnerInfo: this.formBuilder.group({}),
    });

    this.sharedService.getCountryDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.CountryOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {
      }, () => {
      });

    this.sharedService.getStateDropdown().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: DropDownType[]) => {
      data.forEach(element => {
        this.StateOptions.push({
          value: element.id,
          label: element.text
        });
      });
    }, () => {
    }, () => {
    });
  }

  updateDropdownList(currentOptions: any, element: string, isText: boolean = false) {
    const updateList: any[] = [];
    let selectedIndex = -1;
    (Array.isArray(currentOptions) ? currentOptions : []).forEach((el: any, index: number) => {
      const elementValue = isText ? el.label : el.value;
      if (element === elementValue) {
        updateList.push({
          value: el.value,
          label: el.label,
          index: index,
          selected: true,
        });
        selectedIndex = elementValue;
      } else {
        updateList.push({
          value: el.value,
          label: el.label,
          index: el.value,
        });
      }
    });
    return {dropdownData: updateList, index: selectedIndex};
  }

  ngAfterViewInit(): void {
    this.loadStmtData();
  }

  private loadStmtData(): void {
    const data = this.sharedService.getFormData();
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      this.editMode = true;
      data.children?.forEach((stmt: StmtAttrData) => {
        if (this.attMap[stmt.attributeName] == undefined) {
          this.attMap[stmt.attributeName] = [];
        }
        if (stmt.attributeValue != null) {
          this.attMap[stmt.attributeName].push(stmt.attributeValue);
        }
      });

      // Restore FDE/FB Info
      if (this.attMap['f8858FrgnDisAcctPeriodBeginDt'] && this.attMap['f8858FrgnDisAcctPeriodBeginDt'][0]) {
        this.AnnualAcctPeriodBeginDt = new Date(this.attMap['f8858FrgnDisAcctPeriodBeginDt'][0].replace(/-/g, '\/').replace(/T.+/, ''));
      }
      if (this.attMap['f8858FrgnDisAcctPeriodEndDt'] && this.attMap['f8858FrgnDisAcctPeriodEndDt'][0]) {
        this.AnnualAcctPeriodEndDt = new Date(this.attMap['f8858FrgnDisAcctPeriodEndDt'][0].replace(/-/g, '\/').replace(/T.+/, ''));
      }
      if (this.attMap['f8858FbusPersonInd'] && this.attMap['f8858FbusPersonInd'][0]) {
        const updatedData = this.updateDropdownList(this.FDEFBTypeOptions, this.attMap['f8858FbusPersonInd'][0]);
        this.FDEFBTypeOptions = updatedData.dropdownData;
        this.selectedFDEFBType = updatedData.index;
        this.selectedFDEFBTypeItem = this.FDEFBTypeOptions.find((i: any) => i.selected) || null;
      }
      if (this.attMap['f8858InitialFormInd'] && this.attMap['f8858InitialFormInd'][0]) {
        const updatedData = this.updateDropdownList(this.ReturnStatusOptions, this.attMap['f8858InitialFormInd'][0]);
        this.ReturnStatusOptions = updatedData.dropdownData;
        this.selectedReturnStatus = updatedData.index;
        this.selectedReturnStatusItem = this.ReturnStatusOptions.find((i: any) => i.selected) || null;
      }

      // Restore Schedule G
      if (this.attMap['f8858SchGDualCnslLossAmt'] && this.attMap['f8858SchGDualCnslLossAmt'][0]) {
        this.NetIncomeLossAmt = stripAmountFormatting(this.attMap['f8858SchGDualCnslLossAmt'][0]); // 10b
      }
      if (this.attMap['f8858SchGSepCombDualLossAmt'] && this.attMap['f8858SchGSepCombDualLossAmt'][0]) {
        this.DualConsolidatedLossAmt = stripAmountFormatting(this.attMap['f8858SchGSepCombDualLossAmt'][0]); // 11b
      }
      if (this.attMap['f8858SchGNetIncmLossAmt'] && this.attMap['f8858SchGNetIncmLossAmt'][0]) {
        this.SepCombSepDualCnsldtLossAmt = stripAmountFormatting(this.attMap['f8858SchGNetIncmLossAmt'][0]); // 11c
      }
      if (this.attMap['f8858SchGSepUnitDefRegInd'] && this.attMap['f8858SchGSepUnitDefRegInd'][0]) {
        this.SeparateUnitDefinedInRegInd = this.attMap['f8858SchGSepUnitDefRegInd'][0] === '1';
      }
      if (this.attMap['f8858SchGDualCnslLossTxIncInd'] && this.attMap['f8858SchGDualCnslLossTxIncInd'][0]) {
        this.DualCnsldtLossTaxableIncomeInd = this.attMap['f8858SchGDualCnslLossTxIncInd'][0] === '1';
      }
      if (this.attMap['f8858SchGPermCnslLossInd'] && this.attMap['f8858SchGPermCnslLossInd'][0]) {
        this.PermittedDomDualCnsldtLossInd = this.attMap['f8858SchGPermCnslLossInd'][0] === '1';
      }
      if (this.attMap['f8858SchGDualCnslLossDcmntnInd'] && this.attMap['f8858SchGDualCnslLossDcmntnInd'][0]) {
        this.PrmtDomDualCnsldtLossDcmntnInd = this.attMap['f8858SchGDualCnslLossDcmntnInd'][0] === '1';
      }
      if (this.attMap['f8858SchGCmpDualCnslLossTxInd'] && this.attMap['f8858SchGCmpDualCnslLossTxInd'][0]) {
        this.CmptDualCnsldtLossTxblIncmInd = this.attMap['f8858SchGCmpDualCnslLossTxInd'][0] === '1';
      }
      if (this.attMap['f8858SchGCumilativeRegAmt'] && this.attMap['f8858SchGCumilativeRegAmt'][0]) {
        this.CumulativeRegisterAmt = stripAmountFormatting(this.attMap['f8858SchGCumilativeRegAmt'][0]);
      }
      if (this.attMap['f8858SchGTrigRecapInd'] && this.attMap['f8858SchGTrigRecapInd'][0]) {
        this.TriggeringEventRecaptureInd = this.attMap['f8858SchGTrigRecapInd'][0] === '1';
      }
      if (this.attMap['f8858SchGTrigRecapAmt'] && this.attMap['f8858SchGTrigRecapAmt'][0]) {
        this.TriggeringEventRecaptureAmt = stripAmountFormatting(this.attMap['f8858SchGTrigRecapAmt'][0]);
      }

      // Fill LEID selectors on edit: index 0 = reporting, index 1 = DRC/Separate Unit, index 2 = Tax Owner
      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0: // Reporting Entity LEID
              if (data.primaryleid) {
                element.fillLEID(data.primaryleid);
              }
              break;
            case 1: // DRC/Separate Unit LEID
              if (data.secondaryleid) {
                element.fillLEID(data.secondaryleid);
              }
              break;
            case 2: // Tax Owner LEID
              if (data.branchleid) {
                element.fillLEID(data.branchleid);
              }
              break;
          }
        });
      });
      this.cdref.detectChanges();
    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      this.sharedService.setSavedStatementId(this.statementId);
      this.sharedService.getLoadStatementData(400).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: StmtData) => {
        setTimeout(() => {
          this.leidComponents.toArray()[0]?.fillLEID(this.sharedService.leid);
        }, 300);
      });
    } else {
      this.nameChangeChecked = true;
    }
  }

  onReportingEntityChanged(selectedEntity: DSTEntityDetails | null): void {
    this.reportingEntity = selectedEntity;
    if (!selectedEntity) {
      return;
    }
    this.headerComponent.loadConsolGroups(selectedEntity.LEID, this.dcnId);
    this.nameChangeChecked = true;
  }

  onFDEEntityChanged(selectedEntity: DSTEntityDetails | null): void {
    this.fdeEntity = selectedEntity;
    if (!selectedEntity) {
      // Clear all FDE/FB fields
      this.FDEOrFBName = '';
      this.FDEOrFBAddressLine1 = '';
      this.FDEOrFBAddressLine2 = '';
      this.FDEOrFBCity = '';
      this.FDEOrFBCountryCd = '';
      this.FDEOrFBPostalCd = '';
      this.FDEEIN = '';
      this.ForeignEntityRefIdNum = '';
      return;
    }
    // Auto-fill FDE/FB info from Entity Ops
    this.FDEOrFBName = selectedEntity.ENTITY || '';
    this.FDEOrFBAddressLine1 = selectedEntity.ADDRESS1 || '';
    this.FDEOrFBAddressLine2 = selectedEntity.ADDRESS2 || '';
    this.FDEOrFBCity = selectedEntity.CITY || '';
    this.FDEOrFBCountryCd = selectedEntity.COUNTRYNAME || '';
    this.FDEOrFBPostalCd = selectedEntity.ZIP || '';
    this.FDEEIN = selectedEntity.EIN || '';

    // If EIN is blank, generate reference ID as "8858" + LEID
    if (!this.FDEEIN) {
      this.ForeignEntityRefIdNum = '8858' + selectedEntity.LEID;
    } else {
      this.ForeignEntityRefIdNum = '';
    }

    // Update country dropdown
    if (selectedEntity.COUNTRY) {
      const updatedData = this.updateDropdownList(this.CountryOptions, selectedEntity.COUNTRY);
      this.CountryOptions = updatedData.dropdownData;
      this.selectedCountry = updatedData.index;
    }

    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.fdeEntity!, this.taxOwnerEntity!]);
    this.showDREMsg = !!this.DREMsg;
    this.nameChangeChecked = true;
  }

  onTaxOwnerEntityChanged(selectedEntity: DSTEntityDetails | null): void {
    this.taxOwnerEntity = selectedEntity;
    if (!selectedEntity) {
      // Clear all Tax Owner fields
      this.TaxOwnerName = '';
      this.TaxOwnerAddressLine1 = '';
      this.TaxOwnerAddressLine2 = '';
      this.TaxOwnerCity = '';
      this.TaxOwnerState = '';
      this.TaxOwnerZIP = '';
      this.TaxOwnerEIN = '';
      this.stateNameForTaxOwner = '';
      return;
    }
    // Auto-fill Tax Owner info from Entity Ops
    this.TaxOwnerName = selectedEntity.ENTITY || '';
    this.TaxOwnerAddressLine1 = selectedEntity.ADDRESS1 || '';
    this.TaxOwnerAddressLine2 = selectedEntity.ADDRESS2 || '';
    this.TaxOwnerCity = selectedEntity.CITY || '';
    this.TaxOwnerZIP = selectedEntity.ZIP || '';
    this.TaxOwnerEIN = selectedEntity.EIN || '';

    // Resolve state name
    const selectedState: any = this.StateOptions.find((s: any) => s.value === selectedEntity.STATE);
    if (selectedState) {
      this.TaxOwnerState = selectedState.label;
      this.stateNameForTaxOwner = selectedState.label;
    } else {
      this.TaxOwnerState = selectedEntity.STATE || '';
      this.stateNameForTaxOwner = selectedEntity.STATE || '';
    }

    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.taxOwnerEntity!, this.fdeEntity!]);
    this.showDREMsg = !!this.DREMsg;
    this.nameChangeChecked = true;
  }

  onFormOptionChanged(selectedOptionID: Event): void {
    this.selectedOptionID = selectedOptionID;
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  onFDEFBTypeChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedFDEFBTypeItem = change;
    this.selectedFDEFBType = change?.value;
  }

  onReturnStatusChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedReturnStatusItem = change;
    this.selectedReturnStatus = change?.value;
  }

  countryChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCountry = change?.value;
  }

  // Schedule G radio button handlers
  checkSeparateUnitInd(val: boolean): void {
    this.SeparateUnitDefinedInRegInd = val;
    if (val) {
      this.NetIncomeLossAmt = '';
    } else {
      this.DualConsolidatedLossAmt = '';
      this.SepCombSepDualCnsldtLossAmt = '';
    }
  }

  clearSeparateUnitInd(): void {
    this.SeparateUnitDefinedInRegInd = undefined;
    this.NetIncomeLossAmt = '';
    this.DualConsolidatedLossAmt = '';
    this.SepCombSepDualCnsldtLossAmt = '';
    this.cdref.detectChanges();
  }

  checkSepCombInd(val: boolean): void {
    this.SepCombSepDualCnsldtLossInd = val;
  }

  checkDualCnsldtLossTaxableIncomeInd(val: boolean): void {
    this.DualCnsldtLossTaxableIncomeInd = val;
    if (val === false) {
      // If 12a = No, clear 12b, 12c, 12d values
      this.PermittedDomDualCnsldtLossInd = null;
      this.PrmtDomDualCnsldtLossDcmntnInd = null;
      this.CmptDualCnsldtLossTxblIncmInd = null;
    }
    this.cdref.detectChanges();
  }

  checkPermittedDomInd(val: boolean): void {
    this.PermittedDomDualCnsldtLossInd = val;
    if (val === false) {
      // If 12b = No, clear 12c only; user proceeds to 12d per IRS instructions
      this.PrmtDomDualCnsldtLossDcmntnInd = null;
    }
    this.cdref.detectChanges();
  }

  clearPermittedDomInd(): void {
    this.PermittedDomDualCnsldtLossInd = null;
    this.PrmtDomDualCnsldtLossDcmntnInd = null;
    this.CmptDualCnsldtLossTxblIncmInd = null;
    this.cdref.detectChanges();
  }

  checkPrmtDomDcmntnInd(val: boolean): void {
    this.PrmtDomDualCnsldtLossDcmntnInd = val;
    if (val === true) {
      // If 12c = Yes, clear 12d value
      this.CmptDualCnsldtLossTxblIncmInd = null;
    }
    this.cdref.detectChanges();
  }

  clearPrmtDomDcmntnInd(): void {
    this.PrmtDomDualCnsldtLossDcmntnInd = null;
    this.cdref.detectChanges();
  }

  checkCmptDualCnsldtInd(val: boolean): void {
    this.CmptDualCnsldtLossTxblIncmInd = val;
  }

  clearCmptDualCnsldtInd(): void {
    this.CmptDualCnsldtLossTxblIncmInd = null;
    this.cdref.detectChanges();
  }

  checkTriggeringEventInd(val: boolean): void {
    this.TriggeringEventRecaptureInd = val;
  }

  onDPOpen(): void {
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  dateChange(event: any, index: number): void {
    switch (index) {
      case 1:
        this.AnnualAcctPeriodBeginDt = event.startDate.format('YYYY-MM-DD');
        break;
      case 2:
        this.AnnualAcctPeriodEndDt = event.startDate.format('YYYY-MM-DD');
        break;
      default:
        break;
    }
  }

  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.AnnualAcctPeriodBeginDt = '';
        this.form400.get('fdeInfo')?.get('AnnualAcctPeriodBeginDt')?.setValue('');
        this.form400.get('fdeInfo')?.get('AnnualAcctPeriodBeginDt')?.markAsTouched();
        break;
      case 2:
        this.AnnualAcctPeriodEndDt = '';
        this.form400.get('fdeInfo')?.get('AnnualAcctPeriodEndDt')?.setValue('');
        this.form400.get('fdeInfo')?.get('AnnualAcctPeriodEndDt')?.markAsTouched();
        break;
      default:
        break;
    }
    this.cdref.detectChanges();
    // Fallback clear for app-date-picker rendering.
    setTimeout(() => {
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  private forceClearDatePickerInputs(index: number): void {
    try {
      const formControlNames = ['AnnualAcctPeriodBeginDt', 'AnnualAcctPeriodEndDt'];
      const formControlName = formControlNames[index - 1];
      if (formControlName) {
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input') as HTMLInputElement | null;
          if (inputElement && inputElement.value) {
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  // Conditional logic helpers for Schedule G
  // 10a = Yes drives visibility of 11b, 11c
  get show10aYesSection(): boolean {
    return this.SeparateUnitDefinedInRegInd === true;
  }

  // 10a = No drives visibility of 10b
  get show10aNoSection(): boolean {
    return this.SeparateUnitDefinedInRegInd === false;
  }

  get showTriggeringRecaptureAmt(): boolean {
    return this.TriggeringEventRecaptureInd === true;
  }

  // 12a !== false drives visibility of 12b (visible when null or true, hidden when false)
  get show12b(): boolean {
    return this.DualCnsldtLossTaxableIncomeInd !== false;
  }

  // 12c visible only when 12a is not No AND 12b is Yes
  get show12c(): boolean {
    return this.show12b && this.PermittedDomDualCnsldtLossInd === true;
  }

  // 12d visible when 12a is not No AND (12b is No OR (12b is Yes AND 12c is not Yes))
  get show12d(): boolean {
    if (!this.show12b || this.PermittedDomDualCnsldtLossInd == null) {
      return false;
    }
    if (this.PermittedDomDualCnsldtLossInd === false) {
      return true;
    }
    return this.PrmtDomDualCnsldtLossDcmntnInd !== true;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;

    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.fdeEntity, this.taxOwnerEntity])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.reportingEntity),
        'secondaryEntityId': safeEntityId(this.fdeEntity),
        'branchEntityId': safeEntityId(this.taxOwnerEntity),
        'comments': '',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
      };

      const jsonObject: { [key: string]: string } = {
        'f8858FrgnDisAcctPeriodBeginDt': this.sharedService.getTransDateStr(this.AnnualAcctPeriodBeginDt),
        'f8858FrgnDisAcctPeriodEndDt': this.sharedService.getTransDateStr(this.AnnualAcctPeriodEndDt),
        'f8858FbusPersonInd': this.selectedFDEFBType !== -1 ? toSaveString(this.selectedFDEFBType) : '',
        'f8858InitialFormInd': this.selectedReturnStatus !== -1 ? toSaveString(this.selectedReturnStatus) : '',
        'f8858SchGSepUnitDefRegInd': this.SeparateUnitDefinedInRegInd !== undefined ? (this.SeparateUnitDefinedInRegInd ? '1' : '0') : '',
        'f8858SchGDualCnslLossAmt': this.show10aNoSection ? stripAmountFormatting(toSaveString(this.NetIncomeLossAmt)) : '', // 10b
        'f8858SchGSepCombDualLossAmt': this.show10aYesSection ? stripAmountFormatting(toSaveString(this.DualConsolidatedLossAmt)) : '', // 11b
        'f8858SchGNetIncmLossAmt': this.show10aYesSection ? stripAmountFormatting(toSaveString(this.SepCombSepDualCnsldtLossAmt)) : '', // 11c
        'f8858SchGDualCnslLossTxIncInd': this.DualCnsldtLossTaxableIncomeInd !== undefined ? (this.DualCnsldtLossTaxableIncomeInd ? '1' : '0') : '',
        'f8858SchGPermCnslLossInd': this.PermittedDomDualCnsldtLossInd != null ? (this.PermittedDomDualCnsldtLossInd ? '1' : '0') : '',
        'f8858SchGDualCnslLossDcmntnInd': this.PrmtDomDualCnsldtLossDcmntnInd != null ? (this.PrmtDomDualCnsldtLossDcmntnInd ? '1' : '0') : '',
        'f8858SchGCmpDualCnslLossTxInd': this.CmptDualCnsldtLossTxblIncmInd != null ? (this.CmptDualCnsldtLossTxblIncmInd ? '1' : '0') : '',
        'f8858SchGCumilativeRegAmt': stripAmountFormatting(toSaveString(this.CumulativeRegisterAmt)),
        'f8858SchGTrigRecapInd': this.TriggeringEventRecaptureInd !== undefined ? (this.TriggeringEventRecaptureInd ? '1' : '0') : '',
        'f8858SchGTrigRecapAmt': this.showTriggeringRecaptureAmt ? stripAmountFormatting(toSaveString(this.TriggeringEventRecaptureAmt)) : '',
      };

      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit();
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
        this.startLoader = false;
      });
    }
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  isFormValid(placeholder: boolean): boolean {
    if (placeholder) {
      if (!this.reportingEntity) {
        this.dstSharedService.showAlert('error', 'Please specify the LEID of the reporting entity');
        return false;
      }
      if (!this.fdeEntity) {
        this.dstSharedService.showAlert('error', 'Please specify the DRC/Separate Unit LEID');
        return false;
      }
      return true;
    } else {
      if (!this.reportingEntity) {
        this.dstSharedService.showAlert('error', 'Please specify the LEID of the reporting entity');
        return false;
      }
      if (!this.fdeEntity) {
        this.dstSharedService.showAlert('error', 'Please specify the DRC/Separate Unit LEID');
        return false;
      }
      if (this.selectedFDEFBType === -1 || toSaveString(this.selectedFDEFBType) === '') {
        this.dstSharedService.showAlert('error', 'Please select the FDE/FB Type');
        return false;
      }
      if (!this.taxOwnerEntity) {
        this.dstSharedService.showAlert('error', 'Please specify the DRC/Separate Unit U.S. Tax Owner LEID');
        return false;
      }
      if (this.AnnualAcctPeriodBeginDt === '' || this.AnnualAcctPeriodBeginDt === null) {
        this.dstSharedService.showAlert('error', 'Please enter the Annual Accounting Period Beginning Date');
        return false;
      }
      if (this.AnnualAcctPeriodEndDt === '' || this.AnnualAcctPeriodEndDt === null) {
        this.dstSharedService.showAlert('error', 'Please enter the Annual Accounting Period Ending Date');
        return false;
      }
      return true;
    }
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.label || item?.text || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }
}

export type AppkitDropdownOptions = DataEntity[];

export interface DataEntity {
  value: number | string;
  label: string;
  index?: number;
  selected?: boolean;
}
